// Import model
import { ProjectCondition } from '../models/ProjectCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ProjectIndexedFields } from '../models/ProjectIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ProjectIndexedFieldsSerializer } from './ProjectIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProjectCondition - handles JSON serialization and deserialization with type validation
 */
export class ProjectConditionSerializer {
  /**
   * Deserializes a JSON string into a ProjectCondition instance
   */
  static deserialize(json: string): ProjectCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProjectCondition instance
   */
  static fromObject(obj: any): ProjectCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProjectCondition');
    }


    const instance: ProjectCondition = {
      fieldName: obj['fieldName'] as ProjectIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProjectCondition instances
   */
  static deserializeArray(json: string): ProjectCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProjectCondition instance to a JSON string
   */
  static serialize(instance: ProjectCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProjectCondition instance to a plain object
   */
  static toObject(instance: ProjectCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ProjectCondition instances to a JSON string
   */
  static serializeArray(instances: ProjectCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
